import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeDeCH from '@angular/common/locales/de-CH';

import { AppComponent } from './app.component';
import { UiKitComponent } from './ui-kit/ui-kit.component';
import { RouterOutlet } from "@angular/router";
import { AppRoutingModule } from "./app-routing.module";
import { MatIconModule } from "@angular/material/icon";
import { AmplifyLoginComponent } from './modules/auth/amplify-login/amplify-login.component';
import { AmplifyAuthenticatorModule } from "@aws-amplify/ui-angular";
import { MatButtonModule } from "@angular/material/button";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Amplify } from "aws-amplify";
import awsconfig from "../aws-exports";
import { environment } from "../environments/environment";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { provideHttpClient, withInterceptorsFromDi, withXhr } from "@angular/common/http";
import { provideTranslateService, TranslatePipe } from "@ngx-translate/core";
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { MyPetsPageComponent } from './pages/my-pets-page/my-pets-page.component';
import { PetsCarouselComponent } from './modules/pet/pets-carousel/pets-carousel.component';
import { PetCardComponent } from './modules/pet/pet-card/pet-card.component';
import { InvoiceListComponent } from './modules/invoices/list/invoice-list.component';
import { InvoiceListPageComponent } from './pages/invoice-list-page/invoice-list-page.component';
import { InvoiceDetailsComponent } from './modules/invoices/details/invoice-details.component';
import { InvoiceDetailPageComponent } from './pages/invoice-detail-page/invoice-detail-page.component';
import { HeaderComponent } from './components/header/header.component';
import { HeaderWrapperComponent } from './pages/header-wrapper/header-wrapper.component';
import { BottomListsWrapperComponent } from './modules/pet/bottom-lists-wrapper/bottom-lists-wrapper.component';
import { InsuranceOverviewPageComponent } from './pages/insurance-overview-page/insurance-overview-page.component';
import { InsuranceDetailsComponent } from './modules/insurance/details/insurance-details.component';
import { InsuranceDetailsPageComponent } from './pages/insurance-details-page/insurance-details-page.component';
import {
  GeneralConfirmationModalComponent
} from "./components/general-confirmation-modal/general-confirmation-modal.component";
import { MatDialogModule } from "@angular/material/dialog";
import { InsuranceOverviewComponent } from "./modules/insurance/overview/insurance-overview.component";
import { ClaimsListComponent } from './modules/claims/list/claims-list.component';
import { ClaimsListPageComponent } from './pages/claims-list-page/claims-list-page.component';
import { ClaimsDetailsComponent } from './modules/claims/details/claims-details.component';
import { ClaimsDetailsPageComponent } from './pages/claims-details-page/claims-details-page.component';
import { AccountComponent } from './modules/auth/account/account.component';
import {
  AccountAttributeChangeModalComponent
} from './components/account-attribute-change-modal/account-attribute-change-modal.component';
import { ChangePasswordComponent } from './modules/auth/change-password/change-password.component';
import { EditPetInfoComponent } from './modules/insurance/edit-pet-info/edit-pet-info.component';
import { EditPetInfoPageComponent } from './pages/edit-pet-info-page/edit-pet-info-page.component';
import { BooleanTranslatePipe } from "./utils/boolean-translate.pipe";
import { GenderTranslatePipe } from "./utils/gender-translate.pipe";
import { MatSelectModule } from "@angular/material/select";
import { EditInsuranceInfoComponent } from './modules/insurance/edit-insurance-info/edit-insurance-info.component';
import { EditInsuranceInfoPageComponent } from './pages/edit-insurance-info-page/edit-insurance-info-page.component';
import { IconRegistryService } from "./services/icon-registry.service";
import { PetFnolComponent } from './modules/pet/pet-fnol/pet-fnol.component';
import { PetFnolPageComponent } from './pages/pet-fnol-page/pet-fnol-page.component';
import { AutocompleteComponent } from "./components/autocomplete/autocomplete.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { DragNDropComponent } from "./components/drag-n-drop/drag-n-drop.component";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { DateFormat } from "./models";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MatChipsModule } from "@angular/material/chips";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { SelectPetCardsModalComponent } from './components/select-pet-cards-modal/select-pet-cards-modal.component';
import { PetCardListComponent } from './modules/pet/pet-card-list/pet-card-list.component';
import { DesktopHomePageComponent } from './pages/desktop-home-page/desktop-home-page.component';
import { DesktopHomeComponent } from './modules/desktop/desktop-home/desktop-home.component';
import { InsuranceCardComponent } from './modules/insurance/insurance-card/insurance-card.component';
import { SideModalComponent } from './components/side-modal/side-modal.component';
import { DesktopSideSubcomponentComponent } from './modules/desktop/desktop-side-subcomponent/desktop-side-subcomponent.component';
import { UserPreviewComponent } from './components/user-preview/user-preview.component';
import { LoadingService } from "./services/loading.service";
import { LoadingComponent } from "./components/loading/loading.component";
import { LoadingScreenComponent } from "./components/loading-screen/loading-screen.component";
import { LoadErrorComponent } from "./components/load-error/load-error.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { FnolRequestDetailsComponent } from './modules/fnol/fnol-request-details/fnol-request-details.component';
import { FnolRequestPreviewComponent } from './modules/fnol/fnol-request-preview/fnol-request-preview.component';
import { FnolRequestDetailsPageComponent } from './pages/fnol-request-details-page/fnol-request-details-page.component';
import { BreedTranslatePipe } from './utils/breed-translate.pipe';
import { SmallNavComponent } from './components/small-nav/small-nav.component';
import { CancellationContractModalComponent } from './components/cancellation-contract-modal/cancellation-contract-modal.component';
import { AccountPreviewComponent } from './modules/auth/account-preview/account-preview.component';
import { ContactUsComponent } from './modules/auth/contact-us/contact-us.component';
import { VouchersListComponent } from './modules/auth/vouchers-list/vouchers-list.component';
import { VoucherDetailsComponent } from './modules/auth/voucher-details/voucher-details.component';
import { ForgotPasswordComponent } from './modules/auth/forgot-password/forgot-password.component';
import { ChatComponent } from './components/chat/chat.component';
import { CancelInsuranceReasonComponent } from './modules/insurance/cancel-insurance-reason/cancel-insurance-reason.component';
import { CancelInsuranceReasonPageComponent } from './pages/cancel-insurance-reason-page/cancel-insurance-reason-page.component';
import { ClipboardModule } from "@angular/cdk/clipboard";
import { SpecieTranslatePipe } from './utils/specie-translate.pipe';
import { CameraPhotoComponent } from './components/camera-photo/camera-photo.component';
import { PhotoCaptureModalComponent } from './components/photo-capture-modal/photo-capture-modal.component';
import { ImageCropperModalComponent } from './components/image-cropper-modal/image-cropper-modal.component';
import { ChangeIbanComponent } from './modules/auth/change-iban/change-iban.component';
import { ChangeIbanPageComponent } from './pages/change-iban-page/change-iban-page.component';
import { ChatHistoryComponent } from './components/chat-history/chat-history.component';
import { ChatClaimDetailsComponent } from './components/chat-claim-details/chat-claim-details.component';
import { ContractLinkModalComponent } from './components/contract-link-modal/contract-link-modal.component';
import { CodeEmailHelpModalComponent } from './components/code-email-help-modal/code-email-help-modal.component';
import { LinkCompletePageComponent } from './pages/link-complete-page/link-complete-page.component';

registerLocaleData(localeDeCH);

Amplify.configure(environment.authDomain
  ? { ...awsconfig, oauth: { ...awsconfig['oauth'], domain: environment.authDomain } }
  : awsconfig);

@NgModule({
  declarations: [
    AppComponent,
    UiKitComponent,
    AmplifyLoginComponent,
    LoginPageComponent,
    MyPetsPageComponent,
    PetsCarouselComponent,
    PetCardComponent,
    InvoiceListComponent,
    InvoiceListPageComponent,
    InvoiceDetailsComponent,
    InvoiceDetailPageComponent,
    HeaderComponent,
    HeaderWrapperComponent,
    BottomListsWrapperComponent,
    InsuranceOverviewComponent,
    InsuranceOverviewPageComponent,
    InsuranceDetailsComponent,
    InsuranceDetailsPageComponent,
    GeneralConfirmationModalComponent,
    ClaimsListComponent,
    ClaimsListPageComponent,
    ClaimsDetailsComponent,
    ClaimsDetailsPageComponent,
    AccountComponent,
    AccountAttributeChangeModalComponent,
    ChangePasswordComponent,
    EditPetInfoComponent,
    EditPetInfoPageComponent,
    BooleanTranslatePipe,
    GenderTranslatePipe,
    EditInsuranceInfoComponent,
    EditInsuranceInfoPageComponent,
    PetFnolComponent,
    PetFnolPageComponent,
    AutocompleteComponent,
    DragNDropComponent,
    SelectPetCardsModalComponent,
    PetCardListComponent,
    DesktopHomePageComponent,
    DesktopHomeComponent,
    InsuranceCardComponent,
    SideModalComponent,
    DesktopSideSubcomponentComponent,
    UserPreviewComponent,
    LoadingComponent,
    LoadingScreenComponent,
    LoadErrorComponent,
    FnolRequestDetailsComponent,
    FnolRequestPreviewComponent,
    FnolRequestDetailsPageComponent,
    BreedTranslatePipe,
    SmallNavComponent,
    CancellationContractModalComponent,
    AccountPreviewComponent,
    ContactUsComponent,
    VouchersListComponent,
    VoucherDetailsComponent,
    ForgotPasswordComponent,
    ChatComponent,
    CancelInsuranceReasonComponent,
    CancelInsuranceReasonPageComponent,
    SpecieTranslatePipe,
    CameraPhotoComponent,
    PhotoCaptureModalComponent,
    ImageCropperModalComponent,
    ChangeIbanComponent,
    ChangeIbanPageComponent,
    ChatHistoryComponent,
    ChatClaimDetailsComponent,
    ContractLinkModalComponent,
    CodeEmailHelpModalComponent,
    LinkCompletePageComponent
  ],
    imports: [
        AppRoutingModule,
        BrowserModule,
        RouterOutlet,
        MatIconModule,
        AmplifyAuthenticatorModule,
        BrowserModule,
        BrowserAnimationsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatProgressSpinnerModule,
        ClipboardModule,
        TranslatePipe
    ],
  providers: [IconRegistryService, LoadingService,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: DateFormat },
    { provide: LOCALE_ID, useValue: 'de-CH' },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideTranslateService({
      loader: provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' })
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
